import axios from '@/axios';

const RESOURCE_NAME = '/search';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    getRelatedKeywords(data) {
        return axios.post(`${RESOURCE_NAME}/get-related-words`, data)
    },

    getSimilar(data) {
        return axios.post(`${RESOURCE_NAME}/get-similar`, data)
    },
}
